import { useAuthedUser } from '../../../../common/providers/AuthedUserProvider';
import { TrustedContactForm } from '../../../../investment-profile/components/TrustedContactForm';
import { exitToFinancialProfile } from '../../../../investment-profile/navigation';

const TrustedContactPage = () => {
    const user = useAuthedUser();
    return (
        <TrustedContactForm
            userId={user.id}
            onSkip={exitToFinancialProfile}
            onSuccess={exitToFinancialProfile}
        />
    );
};

export default TrustedContactPage;
